import { render, staticRenderFns } from "./EmployeeCards.vue?vue&type=template&id=315a62f9&scoped=true&"
import script from "./EmployeeCards.vue?vue&type=script&lang=js&"
export * from "./EmployeeCards.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCards.vue?vue&type=style&index=0&id=315a62f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a62f9",
  null
  
)

export default component.exports